import { render, staticRenderFns } from "./PReturnDialog.vue?vue&type=template&id=1a216bee"
import script from "./PReturnDialog.vue?vue&type=script&lang=js"
export * from "./PReturnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports